import { useMutation } from '@apollo/client'
import { useState, useRef } from 'react'
import { Flex, Box, Text, Heading, Button } from 'rebass/styled-components'
import { toast } from 'react-toastify';
import { SEND_SMS_TO_PATIENT } from '../graphql/mutations'
import { ISendSmsToPatientInput, ISendSmsToPatientOutput } from '../graphql/types/mutations/conversation'
import { IUser } from '../graphql/types/queries/user'
import withSession from '../lib/withSession'
import { TextAreaNoForm } from './TextArea';
import Select, { ActionMeta, components } from 'react-select';

interface ISendSmsProps {
  id: string
  name: string
  close: () => void
  session: IUser
}
const customStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    borderBottom: '0px dotted pink',
    color: '#344F7A',
    padding: '8px 12px',
    backgroundColor: 'transparent'
  }),
  control: (provided: any) => ({
    ...provided,
    border: 0,
    boxShadow: 'none',
    borderRadius: '10px',
    background: 'transparent',
    paddingLeft: '8px',
    minWidth: '200px'
  }),
  singleValue: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#2196F3',
      fontSize: '12px'
    };
  }, dropdownIndicator: (base: any) => ({
    ...base,
    color: "#2196F3" // Custom colour
  })
  ,
  Input: (provided: any) => ({
    ...provided,
    color: '#2196F3',
  }),
  indicatorSeparator: (provided: any) => ({
    ...provided,
    backgroundColor: '#2196F3',
  }),
  indicatorContainer: (provided: any) => ({
    ...provided,
    color: '#2196F3',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #EBEBEB',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
  }),
}

const SendSms: React.FC<ISendSmsProps> = ({ id, close, session, name }) => {
  const [message, setMessage] = useState<string>(`Hi, our appointment started. Please join me here: ${session.zocdocVideoLink}. Please remember to knock`);

  const TEMPLATES = [
    { label: 'Visit Started', value: `Hi, our appointment started. Please join me here: ${session.zocdocVideoLink}. Please remember to knock` },
    { label: 'Running Late', value: `Hi there! Just a quick heads-up — I’m running a few minutes behind. Thank you for your patience and I’ll be online for your visit shortly.` }
  ]

  const [sendSms, { loading: loadingSendSms }] = useMutation<ISendSmsToPatientOutput, ISendSmsToPatientInput>(SEND_SMS_TO_PATIENT)

  const toastId = useRef<any>(null);
  const _send = async () => {

    toastId.current = toast("Sending SMS", { autoClose: false, isLoading: true, closeButton: false });

    const res = await sendSms({
      variables: {
        id,
        message
      }
    })

    if (res && res.data && res.data.providerSendSMS) {
      if (res.data.providerSendSMS.ok) {
        toast.update(toastId.current, {
          render: 'SMS Sent!',
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
        close()
      } else {
        toast.update(toastId.current, {
          render: res.data.providerSendSMS.customError || 'An error occured',
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      }
    } else {
      toast.update(toastId.current, {
        render: 'An error occured',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
    }
  }

  return (
    <Box style={{ margin: '0 auto', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <Heading mb={3}>Send SMS</Heading>
      <Text mb={4} >Send SMS to {name} - {id}</Text>
      <Flex alignItems={'center'} justifyContent={'center'} mb={3}>
        <Text mr={2}>Predefined template:</Text>
        <Select
          isSearchable={false}
          // styles={customStyles}
          options={TEMPLATES}
          value={TEMPLATES.find(x => x.value === message)}
          onChange={(option) => {
            if (!option) return
            setMessage(option.value)

          }} />
      </Flex>
      <TextAreaNoForm
        autoFocus
        style={{ backgroundColor: 'white', flex: 1, minWidth: '430px', minHeight: '200px' }}
        placeholder='last name or patient id'
        onChange={(e: any) => setMessage(e.target.value)}
        value={message}

      />
      <Flex flexDirection={'row'} justifyContent='space-between' width={'100%'}>
        <Button variant={'pink'} onClick={close} mt={4} disabled={!!loadingSendSms}>Cancel</Button>
        <Button variant={'primary'} onClick={_send} mt={4} disabled={!!loadingSendSms || !message || message.length < 2}>Send</Button>
      </Flex>
      <Box onClick={close} style={{ cursor: 'pointer', position: 'absolute', top: '-10px', right: '-10px', height: '34px', width: '34px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F8A294', padding: '6px', borderRadius: '50%', color: 'white' }}>
        X
      </Box>
    </Box>);
}

export default withSession<ISendSmsProps>(SendSms)